import { Route, Routes } from "react-router-dom";
import { LoginCard, RequireAuth, useTheme } from "@vimaana/ui";
import Shell from "./components/Shell";

const APP_NAME = "kontor";
const APP_TITLE = "Kontor";

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/*" element={<RequireAuth appName={APP_NAME}><Shell /></RequireAuth>} />
    </Routes>
  );
}

function LoginPage() {
  const { theme, toggleTheme } = useTheme();
  return (
    <div className="kontor-login-theme">
      <button
        type="button"
        onClick={toggleTheme}
        aria-label={theme === "dark" ? "Auf helles Design wechseln" : "Auf dunkles Design wechseln"}
      >
        {theme === "dark" ? "☀ Hell" : "☾ Dunkel"}
      </button>
      <LoginCard appName={APP_NAME} appTitle={APP_TITLE} redirectAfterLogin="/planung" />
    </div>
  );
}
